<template>
  <div>
    <div class="row pointer notification mb-1" @click="goToUrl(notification.id)">
      <div class="col-11">
        <p :class="[notification.read_at ? '' : 'font-weight-bold']">
          {{ template }}
          <br />
          <span class="timestamp">
            {{ timestamp }}
          </span>
        </p>
      </div>
      <div class="col-1">
        <i :class="[notification.read_at ? '' : 'fa fa-circle blue']" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import axios from 'axios';

export default {
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    template() {
      return this.notification.data.template
        .split('{{ref_id}}')
        .join(this.notification.data.ref_id);
    },
    timestamp() {
      return moment(this.notification.created_at).format('hh:mm A');
    },
  },
  methods: {
    ...mapActions(['getNotifications']),
    ...mapMutations(['markOneAsRead']),
    goToUrl(id) {
      axios.post(`/clusters/users/notifications/${id}`, {}).then(() => {
        this.$emit('close');
        if (!this.notification.read_at) {
          this.markOneAsRead();
        }
        this.getNotifications();
        if (
          this.notification.type === `App\\Notifications\\NewWebQuote` ||
          this.notification.type === `App\\Notifications\\LeadLinkExpired` ||
          this.notification.type === 'App\\Notifications\\LeadAssigned'
        ) {
          this.$router.push(
            `/leads/edit/${this.notification.data.lead_id}?q=${this.notification.data.ref_id}`,
          );
        } else if (
          this.notification.type === `App\\Notifications\\OfficeSettlementAmountUpdated` ||
          this.notification.type === `App\\Notifications\\SubcoSettlementAmountUpdated`
        ) {
          this.$router.push(`/claims/edit/${this.notification.data.claim_id}`);
        } else {
          this.$router.push(
            `/jobs/edit/${this.notification.data.job_id}?q=${this.notification.data.ref_id}`,
          );
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0.5rem !important;
}
.blue {
  color: #2962ff;
}
.timestamp {
  font-size: 11px;
  color: grey;
  margin-top: -12px;
}
.notification:hover {
  background: #f4f4f4;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotificationItem.vue